<template>
    <div class="mb-3" :class="sizeClassObject">
        <temp-ranking-pending-confirmation ref="pendingConfirmationGrid"
                                            @sizeToggle="sizeToggle"
                                            @rejected="pendingConfirmationRejected"
                                            @confirmed="pendingConfirmationConfirmed"
                                            :pendingConfirmationExpanded="expanded">
        </temp-ranking-pending-confirmation>
    </div>
</template>

<script>
    import TempRankingPendingConfirmation from '../../components/dynamic/ranking/TempRankingPendingConfirmation';
    import { DynamicLayoutPageSize } from '../../models/enums';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                expanded: this.size === 12,
            }
        },
        components: {
            TempRankingPendingConfirmation
        },
        methods: {
            sizeToggle() {
                this.expanded = !this.expanded;
            },
            pendingConfirmationRejected(model) {
                this.reloadUpcomingEventListGrid()
                this.reloadConfrimationsListGrid()
            },
            pendingConfirmationConfirmed(model) {
                this.reloadUpcomingEventListGrid()
                this.reloadConfrimationsListGrid()
            },
            reloadUpcomingEventListGrid() {
                const gr = this.$refs.upcomingEventsGrid
                if (gr) {
                    gr.reload()
                }
            },
            reloadConfrimationsListGrid() {
                const gr = this.$refs.confirmationsListGrid
                if (gr) {
                    gr.reload()
                }
            }
        },
        computed: {
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.expanded ? DynamicLayoutPageSize.Max : Math.min(this.size, 6));
            }
        }
    }
</script>
